import { useEffect, useState } from 'react';
import * as Sentry from '@sentry/react';
import { useStore } from '../context/StoreContext';
import service from '../services/roscaorders.service';

export function useRoscaOrders() {
    const { activeStoreId } = useStore();
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function fetchOrders() {
            setLoading(true);
            try {
                const data = await service.fetchRoscas();
                setOrders(data);
            } catch (error) {
                Sentry.captureException(error);
                console.error('Error fetching rosca orders:', error);
            } finally {
                setLoading(false);
            }
        }
        fetchOrders();
    }, [activeStoreId]);

    return { orders, loading, setOrders };
}
